module.exports = __webpack_public_path__ + "static/1-9373f483d429e4cf381b94644f5e52e1.jpg";